/* eslint-disable no-unused-vars */
import { useEffect, useState } from "react";
import { Route, Routes, useLocation, Navigate, useParams } from "react-router-dom";
import { Elements } from '@stripe/react-stripe-js';
import stripePromise from './services/stripe';
import {
  AboutUs,
  Certifications,
  Associations,
  Social,
  Blogs,
  CustomerDashboard,
  SavedPosts,
  RecentlyViewedPosts,
  Dashboard,
  Home,
  Notifications,
  Messages,
  Quotes,
  Pricing,
  PrivacyPolicy,
  // SellerProfile,
  ServiceDetail,
  Services,
  TermsConditions,
  Licensing,
  TradesPosterBasics,
  HelpCenter,
  UnAuthorized,
  PaymentDetails,
  Draft,
  Published,
  Bin,
  Flagged,
  ResetPassword,
  NotificationSettings,
  SecurityVerification,
  AdminLogin,
  AdminDashboard,
  AdminCustomers,
  AdminCustomerDetail,
  AdminBusinesses,
  AdminBusinessDetail,
  AdminVerificationCompliance,
  AdminVerificationComplianceDetail,
  AdminComplianceRulebook,
  AdminComplianceRuleEditor,
  AdminComplianceArchive,
  AdminComplianceArchiveDetail,
  AdminComplianceReports,
  AdminSecurityFraud,
  AdminSecurityFraudDetail,
  AdminSecurityIncidents,
  AdminSecurityIncidentDetail,
  AdminFraudAlerts,
  AdminFraudSecurityArchive,
  AdminFraudCaseArchiveDetail,
  AdminFraudCaseDetail,
  AdminRestrictions,
  AdminRestrictionDetail,
  AdminAllPosts,
  AdminPostDetail,
  AdminAllReviews,
  AdminReviewDetail,
  AdminBillingDashboard,
  AdminBillingTransactionDetail,
  AdminBusinessBillingRecord,
  AdminBillingReports,
  AdminModerationQueue,
  AdminModerationItemDetail,
  AdminModerationWorkflows,
  AdminWorkflowDetail,
  AdminAutoFlagsViolations,
  AdminViolations,
  AdminAutoFlagDetail,
  AdminViolationDetail,
  AdminViolationCodeDetail,
  AdminModerationRulebook,
  AdminModerationRuleEditor,
  AdminManualReviewQueue,
  AdminManualReviewCaseDetail,
  AdminReports,
  AdminReportDetail,
  AdminMessages,
  AdminMessageDetail,
  AdminQuotes,
  AdminQuoteRequestDetail,
  AdminSupportTickets,
  AdminTicketDetail,
  AdminConfigurationCaseActions,
  AdminConfigurationActionRuleDetail,
  AdminConfigurationSupportTicket,
  AdminConfigurationSupportTicketDetail,
  AdminKnowledgeBase,
  AdminKnowledgeBaseDetail,
  AdminGeneralSettings,
  AdminFeatureToggles,
  AdminPlatformControls,
  AdminAppearanceBranding,
  AdminNotifications,
  AdminTeamMembers,
  AdminRolesPermissions,
  AdminIntegrationsConfig,
  AdminSecurityCompliance,
  AdminBackupRecovery,
  AdminAuditChangeLog,
  AdminDataExport,
  AdminDataRecovery,
  AdminSettingsHistory,
  AdminSystemLogs,
  AdminPrivacyPolicyEdit,
  AdminTermsConditionsEdit,
  AdminBlogPublished,
  AdminBlogDraft,
  AdminBlogDeleted,
  AdminPlatformAnalytics,
  AdminValidation,
  AdminValidationAddRule,
  AdminWorkflow,
  AdminWorkflowAddRule,
  AdminTradeCategories,
  AdminTradeCategoryDetail,
  AdminKeywords,
  AdminKeywordDetail,
  AdminFormInventory,
  AdminFormInventoryDetail,
  AdminVerifications,
  AdminAppealsCases,
  AdminAppealDetail,
  AdminComplianceItems,
  AdminComplianceItemDetail,
  AdminConfigurationKeywords,
  AdminConfigurationKeywordRuleDetail,
  AdminConfigurationFormInventory,
  AdminConfigurationFormInventoryRuleDetail,
  AdminConfigurationVerifications,
  AdminPlans,
  AdminPlanDetail,
  AdminPricingPlans,
  AdminPricingPlanDetail,
  AdminContentControl,
  AdminContentControlDetail,
  AdminFlag,
  AdminFlagRuleDetail,
  AdminPublishing,
  AdminPublishingDetail,
  AdminSearchMatching,
  AdminSearchMatchingRuleDetail,
  AdminQuoteMatchingDistribution,
  AdminQuoteMatchingDistributionRuleDetail,
  AdminAppeals,
  AdminAppealsDetail,
  AdminAppealsTestSimulation,
  AdminConfigurationRuleTestSimulation,
  AdminPermissionsAccess,
  AdminPermissionsAccessDetail,
  AdminPermissionConfigurationDetail,
  AdminDocuments,
  AdminDocumentRuleDetail,
  AdminConfigurationLimitsThresholds,
  AdminConfigurationLimitRuleDetail,
  AdminConfigurationAutomation,
  AdminAutomationRuleDetail,
  AdminConfigurationLifecycle,
  AdminLifecycleRuleDetail,
  AdminConfigurationRetention,
  AdminRetentionRuleDetail,
  AdminNotificationRules,
  AdminNotificationRuleDetail,
} from "./ComponentFile";
import UIComponents from "./pages/UIComponents";
import Spinner from "./components/common/Spinner";
import Layout from "./components/Layout";
import RequireAuth from "./components/RequireAuth";
import RequireAdminAuth from "./components/RequireAdminAuth";
import useAuth from "./Hooks/useAuth";
import { useBusinessCategories } from "./Hooks/useBusinessCategories";
import { usePricingPlan } from "./Hooks/usePricingPlans";
import { useServiceTags } from "./Hooks/useServiceTags";
import Review from "./pages/BusinessDashboard/Inbox/Review";
import Portfolio from "./pages/BusinessDashboard/Settings/Portfolio";
import CreateNewTicket from "./pages/BusinessDashboard/Tickets/CreateNewTicket";
import AllTickets from "./pages/BusinessDashboard/Tickets/AllTickets";
import BusinessTicketDetail from "./pages/BusinessDashboard/Tickets/BusinessTicketDetail";
import Login from "./sections/Login/Login";
import { SignUp } from "./sections/SignUp/SignUp";
import PricingPlans from "./pages/BusinessDashboard/Subscriptions/PricingPlans";
import SelectedCity from "./pages/Popular-cities/SelectedCity";
import PosterProfile from "./pages/PosterProfile";
import BlogTemplate from "./pages/BlogTemplate";
import CreatePost from "./pages/BusinessDashboard/Posting/CreatePost";
import EditPost from "./pages/BusinessDashboard/Posting/EditPost";
import Tradinghours from "./pages/BusinessDashboard/Settings/Tradinghours";
import Payment from "./pages/BusinessDashboard/Settings/Payment";
import CustomerResetPassword from "./pages/CustomerDashboard/Settings/CustomerResetPassword";
import CustomerAccount from "./pages/CustomerDashboard/Settings/CustomerAccount";
import CustMessages from "./pages/CustomerDashboard/Inbox/CustMessages";
import CustQuotes from "./pages/CustomerDashboard/Inbox/CustQuotes";
import BusinessInboxDeleted from "./pages/BusinessDashboard/Inbox/Deleted";
import CustomerInboxDeleted from "./pages/CustomerDashboard/Inbox/Deleted";
import BusinessInboxBlocked from "./pages/BusinessDashboard/Inbox/Blocked";
import CustomerInboxBlocked from "./pages/CustomerDashboard/Inbox/Blocked";
import CustNotifications from "./pages/CustomerDashboard/Inbox/CustNotifications";
import CustReviews from "./pages/CustomerDashboard/Inbox/CustReviews";
import CustomerNotifications from "./pages/CustomerDashboard/Settings/CustomerNotifications";
import Posts from "./pages/CustomerDashboard/Posts";
import CustMobile from "./pages/CustomerDashboard/CustMobile";
import CustDeactivate from "./pages/CustomerDashboard/CustDeactivate";
import CustomerEmail from "./pages/CustomerDashboard/Settings/CustomerEmail";
import Deactivation from "./pages/BusinessDashboard/Deactivation";
import BusinessContact from "./pages/BusinessDashboard/Settings/BusinessContact";
import ServiceCostCal from "./pages/ServiceCostCal";
import CustomerSupport from "./pages/CustomerSupport";
import BusinessSupport from "./pages/BusinessSupport";
import AllServices from "./pages/AllServices";
import ServiceGuide from "./pages/ServiceGuide";
import CreatePostPage from "./pages/CreatePost";
import HelpCenterSection from "./sections/HelpCenter/sections/HelpCenterSection";
import HelpCenterLayout from "./sections/HelpCenter/HelpCenterLayout";
import HelpCenterDetails from "./sections/HelpCenter/sections/HelpCenterDetails";
import ContactUsLayout from "./sections/HelpCenter/ContactUsLayout";
import Accounts from "./pages/BusinessDashboard/Settings/Accounts";
import Following from "./pages/CustomerDashboard/Following";
import CustomerAllTickets from "./pages/CustomerDashboard/Tickets/AllTickets";
import CustomerCreateNewTicket from "./pages/CustomerDashboard/Tickets/CreateNewTicket";
import CustomerTicketDetail from "./pages/CustomerDashboard/Tickets/CustomerTicketDetail";
import BlogCategories from "./pages/BlogCategories";
import ProTags from "./pages/ProTags";
import CouncilRagulators from "./pages/CouncilRagulators";
import AlertsContainer from './components/common/Alerts/AlertsContainer';
import ResetPasswordPage from "./pages/reset-password/ResetPassword";
import { useDispatch } from "react-redux";
import { setUserDetails, clearUserDetails } from "./Redux/Slice/userSlice";
import { initializeAdminSessionFromLogin } from "./Redux/Slice/adminAccessSlice";
import CheckoutSuccess from "./pages/CheckoutSuccess";
import CheckoutCancel from "./pages/CheckoutCancel";
import { GoogleMapsProvider } from "./context/GoogleMapsProvider";
import CookieBanner from "./components/common/CookieBanner/CookieBanner";

const Roles = {
  ADMIN: "admin",
  SELLER: "seller",
  CUSTOMER: "customer",
};

const ProtectedHome = () => {
  const { auth } = useAuth();
  
  // if (auth?.roleType === Roles.SELLER) {
  //   return <Navigate to="/business-dashboard/dashboard" replace />;
  // }
  
  // if (auth?.roleType === Roles.CUSTOMER) {
  //   return <Navigate to="/Services" replace />;
  // }
  
  return <Home />;
};

// Redirect component for messaging threadId
const MessagingRedirect = () => {
  const { threadId } = useParams();
  return <Navigate to={`/admin/communication/all/${threadId}`} replace />;
};

/** Legacy `/admin/quotes/:quoteId` → canonical `/admin/quotes/all/:quoteId` */
const AdminQuoteLegacyRedirect = () => {
  const { threadId } = useParams();
  return <Navigate to={`/admin/quotes/all/${threadId}`} replace />;
};

// Redirect component for security incidentId
const SecurityRedirect = () => {
  const { incidentId } = useParams();
  return <Navigate to={`/admin/fraud/incidents/${incidentId}`} replace />;
};

const ConfigurationPlanViewRedirect = () => {
  return <Navigate to="/admin/configuration/plans" replace />;
};

const BillingTransactionRedirect = () => {
  const { transactionId } = useParams();
  return <Navigate to={`/admin/billing/transactions/${transactionId}`} replace />;
};

const LegacyModerationReportRedirect = () => {
  const { reportId } = useParams();
  return <Navigate to={`/admin/reports/${reportId}`} replace />;
};

function App() {
  const dispatch = useDispatch(); // Add this
  // const { status, data, isFetching } = usePricingPlan();
  // const {
  //   status: businessCategoryStatus,
  //   isFetching: businessCategoryIsFetching,
  // } = useBusinessCategories();
  // const { status: serviceTagsStatus, isFetching: serviceTagsIsFetching } =
  //   useServiceTags();
  const [SignIn, setSignIn] = useState(false);
  const [SignUpState, setSignUpState] = useState(false);
  // let [CookieModelState, setCookieModelState] = useState(true);
  const location = useLocation();
  const { setAuth } = useAuth();

  useEffect(() => {
    // var currentDate = new Date();
    var currentDate = Math.floor(Date.now() / 1000)
    const login = JSON.parse(localStorage.getItem("LoginSession"));
    var expirationDate = login?.expireAt;

    // if (Date.parse(currentDate) < Date.parse(expirationDate)) {
    //   //normal application behaviour => session is not expired
      dispatch(setUserDetails(login));
      setAuth(login);
      dispatch(initializeAdminSessionFromLogin(login));
    // } else {
    //   //redirect users to login page or whatever logic you have in your app
    //   //and remove the sessionStorage because it will be set again by previous logic
    //   localStorage.removeItem("LoginSession");
    //   setAuth(null);
    // }

    const open = () => {
      setSignIn(true);
    };
    setTimeout(open, 300);
    return () => {
      clearTimeout(open);
      setSignIn(false);
      setSignUpState(false);
    };
  }, [location, setAuth]);
  // { path: '/seller-profile', name: 'Profile', element: List, exact: true },
  //   { path: '/seller-profile/profile-form', name: 'ProfileForm', element: Profiling, exact: true },
  //   { path: '/seller-profile/profile-form/:id', name: 'ProfileForm', element: Profiling },
  // if (businessCategoryStatus === "loading" || status === "loading") {
  //   return <Spinner />;
  // }
  return (
    <>
      <ScrollTop />
      <div className="App">
        <GoogleMapsProvider>
          <Elements stripe={stripePromise}>
            <Routes>
            <Route path="/" element={<Layout />}>
              {/* public routes */}
              <Route path="/" element={<ProtectedHome />} />
              <Route path="reset-password" element={<ResetPasswordPage />} />
              <Route path="ui-components" element={<UIComponents />} />
              <Route path="privacy-policy" element={<PrivacyPolicy />} />
              <Route path="terms-&-conditions" element={<TermsConditions />} />
              <Route path="licensing" element={<Licensing />} />
              <Route path="trades-poster-basics" element={<TradesPosterBasics />} />
              <Route
                path="councils-regulations"
                element={<CouncilRagulators />}
              />
              <Route path="contactus" element={<ContactUsLayout />} />
              <Route
                path="HelpCentre/contact-us"
                element={<Navigate to="/contactus" replace />}
              />
              <Route path="HelpCentre" element={<HelpCenterLayout />}>
                <Route index element={<HelpCenter />} />
                <Route path="article/:section" element={<HelpCenterDetails />} />
                <Route
                  path=":section/:subsection"
                  element={<HelpCenterSection />}
                />
                <Route path=":section" element={<HelpCenterSection />} />
              </Route>

              <Route path="about-us" element={<AboutUs />} />
              <Route path="pricing" element={<Pricing />} />
              <Route path="payment/success" element={<CheckoutSuccess />} />
              <Route path="payment/cancel" element={<CheckoutCancel />} />
              <Route path="pro" element={<ProTags />} />
              <Route path="create-post" element={<CreatePostPage />} />
              <Route path="blogs" element={<Blogs />} />
              <Route path="blogs/category-name" element={<BlogCategories />} />
              <Route path="cost-estimation" element={<ServiceCostCal />} />
              <Route
                path="customer-support-centre"
                element={<CustomerSupport />}
              />
              <Route
                path="business-support-centre"
                element={<BusinessSupport />}
              />
              <Route path="services-guide" element={<AllServices />} />
              <Route
                path="blogs/article-id-will-be-here"
                element={<BlogTemplate />}
              />
              <Route
                path="/Services/available-categories-in-the-selected-city"
                element={<SelectedCity />}
              />
              {/* <Route path="/review-guidelines" element={<ReviewGuide />} /> */}
              <Route path="/poster-profile/:id" element={<PosterProfile />} />
              <Route path="/poster-profile" element={<PosterProfile />} />
          
              <Route
                path="/Login"
                element={
                  <>
                    <Login
                      SignIn={SignIn}
                      setSignIn={setSignIn}
                      SignUpState={SignUpState}
                      setSignUpState={setSignUpState}
                    />
                    <SignUp
                      SignUpState={SignUpState}
                      setSignUpState={setSignUpState}
                      SignIn={SignIn}
                      setSignIn={setSignIn}
                    />
                  </>
                }
              />
              <Route
                path="/Signup"
                element={
                  <>
                    <Login
                      SignIn={SignIn}
                      setSignIn={setSignIn}
                      SignUpState={SignUpState}
                      setSignUpState={setSignUpState}
                    />
                    <SignUp
                      SignUpState={SignUpState}
                      setSignUpState={setSignUpState}
                      SignIn={SignIn}
                      setSignIn={setSignIn}
                    />
                  </>
                }
              />
              <Route path="category/:slug" element={<Services />} />
              <Route path="category" element={<Services />} />
              <Route path="service-detail" element={<ServiceDetail />} />
              <Route path="service-detail/:id" element={<ServiceDetail />} />
              <Route path="services-guide/:slug" element={<ServiceGuide />} />
              <Route path="unauthorized" element={<UnAuthorized />} />

              {/* Protected  Routes */}
              <Route
                element={
                  <RequireAuth allowedRoles={[Roles.ADMIN, Roles.CUSTOMER]} />
                }
              >
                <Route
                  path="customer-dashboard/dashboard"
                  element={<CustomerDashboard />}
                />
                <Route
                  path="customer-dashboard/dashboard:userId"
                  element={<CustomerDashboard />}
                />
                <Route path="customer-dashboard/posts" element={<Posts />} />
                <Route path="customer-dashboard/posts/saved" element={<SavedPosts />} />
                <Route path="customer-dashboard/posts/recently-viewed" element={<RecentlyViewedPosts />} />
                <Route
                  path="customer-dashboard/following"
                  element={<Following />}
                />
                <Route
                  path="customer-dashboard/settings/mobile"
                  element={<CustMobile />}
                />
                <Route
                  path="customer-dashboard/settings/email"
                  element={<CustomerEmail />}
                />
                <Route
                  path="customer-dashboard/account-deactivation"
                  element={<CustDeactivate />}
                />
                <Route
                  path="customer-dashboard/account"
                  element={<CustomerAccount />}
                />
                <Route
                  path="customer-dashboard/settings/notification-preferences"
                  element={<CustomerNotifications />}
                />
                <Route
                  path="customer-dashboard/settings/reset-password"
                  element={<CustomerResetPassword />}
                />
                <Route
                  path="customer-dashboard/inbox/chats"
                  element={<CustMessages />}
                />
                <Route
                  path="customer-dashboard/inbox/quotes"
                  element={<CustQuotes />}
                />
                <Route
                  path="customer-dashboard/inbox/deleted"
                  element={<CustomerInboxDeleted />}
                />
                <Route
                  path="customer-dashboard/inbox/blocked"
                  element={<CustomerInboxBlocked />}
                />
                <Route
                  path="customer-dashboard/inbox/notifications"
                  element={<CustNotifications />}
                />
                <Route
                  path="customer-dashboard/inbox/reviews"
                  element={<CustReviews />}
                />
                <Route
                  path="customer-dashboard/tickets/all"
                  element={<CustomerAllTickets />}
                />
                <Route
                  path="customer-dashboard/tickets/open"
                  element={<CustomerAllTickets />}
                />
                <Route
                  path="customer-dashboard/tickets/new"
                  element={<CustomerAllTickets />}
                />
                <Route
                  path="customer-dashboard/tickets/resolved"
                  element={<CustomerAllTickets />}
                />
                <Route
                  path="customer-dashboard/tickets/closed"
                  element={<CustomerAllTickets />}
                />
                <Route
                  path="customer-dashboard/tickets/create"
                  element={<CustomerCreateNewTicket />}
                />
                <Route
                  path="customer-dashboard/tickets/:ticketId"
                  element={<CustomerTicketDetail />}
                />

                {/* <Route path="CustomerReview" element={<Reviews />} />
                <Route path="CustomerReview/:userId" element={<Reviews />} /> */}
              </Route>
              {/* old routes */}
              {/* <Route path="SellerProfile" element={<SellerProfile />} />
              <Route path="SellerProfile/:id/:name" element={<SellerProfile />} /> */}

              <Route
                element={
                  <RequireAuth allowedRoles={[Roles.ADMIN, Roles.SELLER]} />
                }
              >
                <Route
                  path="business-dashboard/dashboard"
                  element={<Dashboard />}
                />
                <Route
                  path="business-dashboard/settings/account"
                  element={<Accounts />}
                />
                <Route
                  path="business-dashboard/account-deactivation"
                  element={<Deactivation />}
                />
                <Route
                  path="business-dashboard/subscriptions/pricing"
                  element={<PricingPlans />}
                />
                <Route
                  path="business-dashboard/subscriptions/billing-details"
                  element={<PaymentDetails />}
                />
                <Route
                  path="business-dashboard/posts/create-post"
                  element={<CreatePost />}
                />
                <Route
                  path="business-dashboard/posts/edit/:postId"
                  element={<CreatePost />}
                />
                <Route
                  path="business-dashboard/posts/drafts"
                  element={<Draft />}
                />
                <Route
                  path="business-dashboard/posts/drafts/:Id/:type"
                  element={<Draft />}
                />
                <Route
                  path="business-dashboard/posts/published"
                  element={<Published />}
                />
                <Route
                  path="business-dashboard/posts/published/:Id/:type"
                  element={<Published />}
                />
                <Route path="business-dashboard/posts/bin" element={<Bin />} />
                <Route
                  path="business-dashboard/posts/bin/:Id/:type"
                  element={<Bin />}
                />
                <Route path="business-dashboard/posts/flagged" element={<Flagged />} />
                <Route
                  path="business-dashboard/posts/flagged/:Id/:type"
                  element={<Flagged />}
                />
                <Route
                  path="business-dashboard/inbox/chats"
                  element={<Messages />}
                />
                <Route
                  path="business-dashboard/inbox/quotes"
                  element={<Quotes />}
                />
                <Route
                  path="business-dashboard/inbox/deleted"
                  element={<BusinessInboxDeleted />}
                />
                <Route
                  path="business-dashboard/inbox/blocked"
                  element={<BusinessInboxBlocked />}
                />
                <Route
                  path="business-dashboard/inbox/notifications"
                  element={<Notifications />}
                />
                <Route
                  path="business-dashboard/inbox/reviews"
                  element={<Review />}
                />
                <Route
                  path="business-dashboard/tickets/all"
                  element={<AllTickets />}
                />
                <Route
                  path="business-dashboard/tickets/open"
                  element={<AllTickets />}
                />
                <Route
                  path="business-dashboard/tickets/new"
                  element={<AllTickets />}
                />
                <Route
                  path="business-dashboard/tickets/resolved"
                  element={<AllTickets />}
                />
                <Route
                  path="business-dashboard/tickets/closed"
                  element={<AllTickets />}
                />
                <Route
                  path="business-dashboard/tickets/create"
                  element={<CreateNewTicket />}
                />
                <Route
                  path="business-dashboard/tickets/:ticketId"
                  element={<BusinessTicketDetail />}
                />
                <Route
                  path="business-dashboard/settings/certifications"
                  element={<Certifications />}
                />
                <Route
                  path="business-dashboard/settings/associations"
                  element={<Associations />}
                />
                <Route
                  path="business-dashboard/settings/social-profiles"
                  element={<Social />}
                />
                <Route
                  path="business-dashboard/settings/trading-hours"
                  element={<Tradinghours />}
                />
                <Route
                  path="business-dashboard/settings/business-contact"
                  element={<BusinessContact />}
                />
                <Route
                  path="business-dashboard/settings/payment-options"
                  element={<Payment />}
                />
                <Route
                  path="business-dashboard/settings/security-verification"
                  element={<SecurityVerification />}
                />
                <Route
                  path="business-dashboard/settings/notification-preferences"
                  element={<NotificationSettings />}
                />
                <Route
                  path="business-dashboard/settings/reset-password"
                  element={<ResetPassword />}
                />
                <Route
                  path="business-dashboard/settings/manage-portfolio"
                  element={<Portfolio />}
                />
              </Route>
            </Route>
                     {/* Admin Routes */}
                     {/* Admin Login - Public route (no authentication required) */}
                     <Route path="/admin" element={<AdminLogin />} />
                     {/* All other admin routes - Protected (requires superadmin role) */}
                    <Route element={<RequireAdminAuth />}>
                      <Route path="/admin/dashboard" element={<AdminDashboard />} />
                      <Route path="/admin/users/customers" element={<AdminCustomers />} />
                      <Route path="/admin/users/customers/:customerId" element={<AdminCustomerDetail />} />
                      <Route path="/admin/users/businesses" element={<AdminBusinesses />} />
                      <Route path="/admin/users/businesses/:businessId" element={<AdminBusinessDetail />} />
                      <Route path="/admin/posts" element={<Navigate to="/admin/posts/all" replace />} />
                      <Route path="/admin/posts/all" element={<AdminAllPosts />} />
                      <Route path="/admin/posts/:postId" element={<AdminPostDetail />} />
                      <Route path="/admin/reviews" element={<Navigate to="/admin/reviews/all" replace />} />
                      <Route path="/admin/reviews/all" element={<AdminAllReviews />} />
                      <Route path="/admin/reviews/:reviewId" element={<AdminReviewDetail />} />
                      {/* Redirect old routes to new ones */}
                      <Route path="/admin/verification" element={<Navigate to="/admin/verification/queue" replace />} />
                      <Route path="/admin/verification/queue" element={<AdminVerificationCompliance />} />
                      {/* Compliance Archive Routes - Must come before :complianceId route */}
                      <Route path="/admin/verification/archive" element={<AdminComplianceArchive />} />
                      <Route path="/admin/verification/archive/:documentId" element={<AdminComplianceArchiveDetail />} />
                      {/* Compliance Rulebook Routes - Must come before :complianceId route */}
                      <Route path="/admin/verification/rules" element={<AdminComplianceRulebook />} />
                      <Route path="/admin/verification/rules/new" element={<AdminComplianceRuleEditor />} />
                      <Route path="/admin/verification/rules/:ruleId" element={<AdminComplianceRuleEditor />} />
                      {/* Compliance Reports Route */}
                      <Route path="/admin/verification/reports" element={<AdminComplianceReports />} />
                      {/* Verification Detail - Must be last to avoid matching archive/rules */}
                      <Route path="/admin/verification/:complianceId" element={<AdminVerificationComplianceDetail />} />
                      {/* Redirect old security routes to new fraud routes */}
                      <Route path="/admin/security" element={<Navigate to="/admin/fraud/incidents" replace />} />
                      <Route path="/admin/security/:incidentId" element={<SecurityRedirect />} />
                      <Route path="/admin/fraud/alerts" element={<AdminFraudAlerts />} />
                      <Route path="/admin/fraud/archive" element={<AdminFraudSecurityArchive />} />
                      <Route path="/admin/fraud/archive/:caseId" element={<AdminFraudCaseArchiveDetail />} />
                      <Route path="/admin/fraud/alerts/:caseId" element={<AdminFraudCaseDetail />} />
                      <Route path="/admin/fraud/restrictions" element={<AdminRestrictions />} />
                      <Route path="/admin/fraud/restrictions/:restrictionId" element={<AdminRestrictionDetail />} />
                      <Route path="/admin/fraud/incidents" element={<AdminSecurityIncidents />} />
                      <Route path="/admin/fraud/incidents/:incidentId" element={<AdminSecurityIncidentDetail />} />
                      <Route path="/admin/finance" element={<Navigate to="/admin/billing/transactions" replace />} />
                      <Route path="/admin/finance/transactions" element={<Navigate to="/admin/billing/transactions" replace />} />
                      <Route path="/admin/billing/transactions" element={<AdminBillingDashboard />} />
                      <Route
                        path="/admin/billing/subscriptions/:businessId"
                        element={<AdminBusinessBillingRecord />}
                      />
                      <Route
                        path="/admin/finance/transactions/:transactionId"
                        element={<BillingTransactionRedirect />}
                      />
                      <Route
                        path="/admin/billing/transactions/:transactionId"
                        element={<AdminBillingTransactionDetail />}
                      />
                      <Route path="/admin/finance/reports" element={<Navigate to="/admin/billing/reports" replace />} />
                      <Route path="/admin/billing/reports" element={<AdminBillingReports />} />
                      <Route path="/admin/moderation/queue" element={<AdminModerationQueue />} />
                      <Route path="/admin/moderation/queue/:itemId" element={<AdminModerationItemDetail />} />
                      <Route path="/admin/moderation/workflows" element={<AdminModerationWorkflows />} />
                      <Route path="/admin/moderation/workflows/:workflowId" element={<AdminWorkflowDetail />} />
                      <Route path="/admin/moderation/violations" element={<AdminViolations />} />
                      <Route path="/admin/moderation/violations/auto-flag/:flagId" element={<AdminAutoFlagDetail />} />
                      <Route path="/admin/moderation/violations/code/:violationCode" element={<AdminViolationCodeDetail />} />
                      <Route path="/admin/moderation/violations/violation/:violationId" element={<AdminViolationDetail />} />
                      <Route path="/admin/moderation/rules" element={<AdminModerationRulebook />} />
                      <Route path="/admin/moderation/rules/new" element={<AdminModerationRuleEditor />} />
                      <Route path="/admin/moderation/rules/:ruleId" element={<AdminModerationRuleEditor />} />
                      <Route path="/admin/moderation/manual" element={<AdminManualReviewQueue />} />
                      <Route path="/admin/moderation/manual/:caseId" element={<AdminManualReviewCaseDetail />} />
                      <Route path="/admin/reports" element={<AdminReports />} />
                      <Route path="/admin/reports/:reportId" element={<AdminReportDetail />} />
                      <Route path="/admin/moderation/reports" element={<Navigate to="/admin/reports" replace />} />
                      <Route
                        path="/admin/moderation/reports/:reportId"
                        element={<LegacyModerationReportRedirect />}
                      />
                      <Route path="/admin/analytics/platform" element={<AdminPlatformAnalytics />} />
                      <Route path="/admin/analytics/insight" element={<Navigate to="/admin/analytics/platform" replace />} />
                      <Route path="/admin/messaging" element={<Navigate to="/admin/communication/all" replace />} />
                      <Route path="/admin/messaging/:threadId" element={<MessagingRedirect />} />
                      <Route path="/admin/communication/all" element={<AdminMessages />} />
                      <Route path="/admin/communication/all/:threadId" element={<AdminMessageDetail />} />
                      <Route path="/admin/quotes/all" element={<AdminQuotes />} />
                      <Route path="/admin/quotes/all/:threadId" element={<AdminMessageDetail />} />
                      <Route path="/admin/quotes/group/:threadId" element={<AdminMessageDetail />} />
                      <Route path="/admin/quotes/requests" element={<Navigate to="/admin/quotes/all" replace />} />
                      <Route path="/admin/quotes/requests/:requestId" element={<AdminQuoteRequestDetail />} />
                      <Route path="/admin/quotes/:threadId" element={<AdminQuoteLegacyRedirect />} />
                      <Route path="/admin/support/tickets" element={<AdminSupportTickets />} />
                      <Route path="/admin/support/tickets/:ticketId" element={<AdminTicketDetail />} />
                      <Route path="/admin/support/routing" element={<Navigate to="/admin/dashboard" replace />} />
                      <Route path="/admin/support/routing/*" element={<Navigate to="/admin/dashboard" replace />} />
                      <Route path="/admin/support/kb" element={<AdminKnowledgeBase />} />
                      <Route path="/admin/support/kb/add" element={<AdminKnowledgeBaseDetail />} />
                      <Route path="/admin/support/kb/new" element={<Navigate to="/admin/support/kb/add" replace />} />
                      <Route path="/admin/support/kb/:articleId/view" element={<AdminKnowledgeBaseDetail />} />
                      <Route path="/admin/support/kb/:articleId/edit" element={<AdminKnowledgeBaseDetail />} />
                      <Route path="/admin/support/kb/:articleId" element={<AdminKnowledgeBaseDetail />} />
                      <Route path="/admin/content/legal/privacy-policy" element={<AdminPrivacyPolicyEdit />} />
                      <Route path="/admin/content/legal/terms-conditions" element={<AdminTermsConditionsEdit />} />
                      <Route path="/admin/content/blog/published" element={<AdminBlogPublished />} />
                      <Route path="/admin/content/blog/draft" element={<AdminBlogDraft />} />
                      <Route path="/admin/content/blog/deleted" element={<AdminBlogDeleted />} />
                      <Route path="/admin/system-logs" element={<AdminSystemLogs />} />
                      <Route path="/admin/configuration/validation" element={<AdminValidation />} />
                      <Route path="/admin/configuration/validation/add" element={<AdminValidationAddRule />} />
                      <Route path="/admin/configuration/validation/:ruleName/edit" element={<AdminValidationAddRule />} />
                      <Route path="/admin/configuration/validation/:ruleName/test" element={<AdminConfigurationRuleTestSimulation />} />
                      <Route path="/admin/configuration/validation/:ruleName" element={<AdminValidationAddRule />} />
                      <Route path="/admin/configuration/compliance" element={<Navigate to="/admin/configuration/case-actions" replace />} />
                      <Route path="/admin/configuration/compliance/*" element={<Navigate to="/admin/configuration/case-actions" replace />} />
                      <Route path="/admin/configuration/compliance-verification" element={<Navigate to="/admin/configuration/case-actions" replace />} />
                      <Route path="/admin/configuration/compliance-verification/*" element={<Navigate to="/admin/configuration/case-actions" replace />} />
                      <Route path="/admin/configuration/licences-badges-trade-tickets" element={<Navigate to="/admin/licences-badges-trade-tickets" replace />} />
                      <Route path="/admin/configuration/licences-badges-trade-tickets/*" element={<Navigate to="/admin/licences-badges-trade-tickets" replace />} />
                      <Route path="/admin/configuration/workflow" element={<AdminWorkflow />} />
                      <Route path="/admin/configuration/workflow/add" element={<AdminWorkflowAddRule />} />
                      <Route path="/admin/configuration/workflow/:ruleName/edit" element={<AdminWorkflowAddRule />} />
                      <Route path="/admin/configuration/workflow/:ruleName/test" element={<AdminConfigurationRuleTestSimulation />} />
                      <Route path="/admin/configuration/workflow/:ruleName" element={<AdminWorkflowAddRule />} />
                      <Route path="/admin/configuration/flagging" element={<Navigate to="/admin/configuration/flag" replace />} />
                      <Route path="/admin/configuration/flagging/*" element={<Navigate to="/admin/configuration/flag" replace />} />
                      <Route path="/admin/keywords" element={<AdminKeywords />} />
                      <Route path="/admin/keywords/add" element={<AdminKeywordDetail />} />
                      <Route path="/admin/keywords/:tradeCategoryId/view" element={<AdminKeywordDetail />} />
                      <Route path="/admin/keywords/:tradeCategoryId/edit" element={<AdminKeywordDetail />} />
                      <Route path="/admin/form-inventory" element={<AdminFormInventory />} />
                      <Route path="/admin/form-inventory/add" element={<AdminFormInventoryDetail />} />
                      <Route path="/admin/form-inventory/:formId/edit" element={<AdminFormInventoryDetail />} />
                      <Route path="/admin/form-inventory/:formId" element={<AdminFormInventoryDetail />} />
                      <Route path="/admin/verifications" element={<AdminVerifications />} />
                      <Route path="/admin/appeals" element={<AdminAppealsCases />} />
                      <Route path="/admin/appeals/:appealId" element={<AdminAppealDetail />} />
                      <Route path="/admin/licences-badges-trade-tickets" element={<AdminComplianceItems />} />
                      <Route path="/admin/licences-badges-trade-tickets/add" element={<AdminComplianceItemDetail />} />
                      <Route path="/admin/licences-badges-trade-tickets/:recordId/edit" element={<AdminComplianceItemDetail />} />
                      <Route
                        path="/admin/licences-badges-trade-tickets/:recordId"
                        element={<Navigate to="./edit" replace />}
                      />
                      <Route path="/admin/configuration/keywords" element={<AdminConfigurationKeywords />} />
                      <Route path="/admin/configuration/keywords/add" element={<AdminConfigurationKeywordRuleDetail />} />
                      <Route path="/admin/configuration/keywords/:keywordName/edit" element={<AdminConfigurationKeywordRuleDetail />} />
                      <Route path="/admin/configuration/keywords/:keywordName" element={<AdminConfigurationKeywordRuleDetail />} />
                      <Route path="/admin/configuration/form-inventory" element={<AdminConfigurationFormInventory />} />
                      <Route path="/admin/configuration/form-inventory/add" element={<AdminConfigurationFormInventoryRuleDetail />} />
                      <Route path="/admin/configuration/form-inventory/:configId/edit" element={<AdminConfigurationFormInventoryRuleDetail />} />
                      <Route path="/admin/configuration/form-inventory/:configId" element={<AdminConfigurationFormInventoryRuleDetail />} />
                      <Route path="/admin/configuration/verifications" element={<AdminConfigurationVerifications />} />
                      <Route path="/admin/trade-categories" element={<AdminTradeCategories />} />
                      <Route path="/admin/trade-categories/add" element={<AdminTradeCategoryDetail />} />
                      <Route path="/admin/trade-categories/:categoryName/edit" element={<AdminTradeCategoryDetail />} />
                      <Route path="/admin/trade-categories/:categoryName" element={<Navigate to="/admin/trade-categories" replace />} />
                      <Route path="/admin/pricing-plans" element={<AdminPricingPlans />} />
                      <Route path="/admin/pricing-plans/add" element={<AdminPricingPlanDetail />} />
                      <Route path="/admin/pricing-plans/:planName/edit" element={<AdminPricingPlanDetail />} />
                      <Route path="/admin/pricing-plans/:planName" element={<AdminPricingPlanDetail />} />
                      <Route path="/admin/configuration/plans" element={<AdminPlans />} />
                      <Route path="/admin/configuration/plans/add" element={<AdminPlanDetail />} />
                      <Route path="/admin/configuration/plans/:configId/edit" element={<AdminPlanDetail />} />
                      <Route path="/admin/configuration/plans/:configId" element={<ConfigurationPlanViewRedirect />} />
                      <Route path="/admin/configuration/content-control" element={<AdminContentControl />} />
                      <Route path="/admin/configuration/content-control/add" element={<AdminContentControlDetail />} />
                      <Route path="/admin/configuration/content-control/:ruleName/edit" element={<AdminContentControlDetail />} />
                      <Route path="/admin/configuration/content-control/:ruleName/test" element={<AdminConfigurationRuleTestSimulation />} />
                      <Route path="/admin/configuration/content-control/:ruleName" element={<AdminContentControlDetail />} />
                      <Route path="/admin/configuration/flag" element={<AdminFlag />} />
                      <Route path="/admin/configuration/flag/add" element={<AdminFlagRuleDetail />} />
                      <Route path="/admin/configuration/flag/:ruleName/edit" element={<AdminFlagRuleDetail />} />
                      <Route path="/admin/configuration/flag/:ruleName" element={<AdminFlagRuleDetail />} />
                      <Route path="/admin/configuration/publishing" element={<AdminPublishing />} />
                      <Route path="/admin/configuration/publishing/add" element={<AdminPublishingDetail />} />
                      <Route path="/admin/configuration/publishing/:ruleName/edit" element={<AdminPublishingDetail />} />
                      <Route path="/admin/configuration/publishing/:ruleName/test" element={<AdminConfigurationRuleTestSimulation />} />
                      <Route path="/admin/configuration/publishing/:ruleName" element={<AdminPublishingDetail />} />
                      <Route path="/admin/configuration/search-matching" element={<AdminSearchMatching />} />
                      <Route path="/admin/configuration/search-matching/add" element={<AdminSearchMatchingRuleDetail />} />
                      <Route path="/admin/configuration/search-matching/:ruleName/edit" element={<AdminSearchMatchingRuleDetail />} />
                      <Route path="/admin/configuration/search-matching/:ruleName" element={<AdminSearchMatchingRuleDetail />} />
                      <Route path="/admin/configuration/quote-matching-distribution" element={<AdminQuoteMatchingDistribution />} />
                      <Route path="/admin/configuration/quote-matching-distribution/add" element={<AdminQuoteMatchingDistributionRuleDetail />} />
                      <Route path="/admin/configuration/quote-matching-distribution/:ruleName/edit" element={<AdminQuoteMatchingDistributionRuleDetail />} />
                      <Route path="/admin/configuration/quote-matching-distribution/:ruleName" element={<AdminQuoteMatchingDistributionRuleDetail />} />
                      <Route path="/admin/configuration/appeals" element={<AdminAppeals />} />
                      <Route path="/admin/configuration/appeals/add" element={<AdminAppealsDetail />} />
                      <Route path="/admin/configuration/appeals/:configId/edit" element={<AdminAppealsDetail />} />
                      <Route path="/admin/configuration/appeals/:configId/test" element={<AdminAppealsTestSimulation />} />
                      <Route path="/admin/configuration/appeals/:configId" element={<AdminAppealsDetail />} />
                      <Route path="/admin/configuration/permissions-access" element={<AdminPermissionsAccess />} />
                      <Route path="/admin/configuration/permissions-access/add" element={<AdminPermissionsAccessDetail />} />
                      <Route path="/admin/configuration/permissions-access/config/:configId/edit" element={<AdminPermissionConfigurationDetail />} />
                      <Route path="/admin/configuration/permissions-access/config/:configId" element={<AdminPermissionConfigurationDetail />} />
                      <Route path="/admin/configuration/permissions-access/member/:memberName/edit" element={<AdminPermissionsAccessDetail />} />
                      <Route path="/admin/configuration/permissions-access/member/:memberName" element={<AdminPermissionsAccessDetail />} />
                      <Route path="/admin/configuration/permissions-access/:memberName/edit" element={<AdminPermissionsAccessDetail />} />
                      <Route path="/admin/configuration/permissions-access/:memberName" element={<AdminPermissionsAccessDetail />} />
                      <Route path="/admin/configuration/documents" element={<AdminDocuments />} />
                      <Route path="/admin/configuration/documents/add" element={<AdminDocumentRuleDetail />} />
                      <Route path="/admin/configuration/documents/verification" element={<Navigate to="/admin/configuration/documents" replace />} />
                      <Route path="/admin/configuration/documents/compliance" element={<Navigate to="/admin/configuration/documents" replace />} />
                      <Route path="/admin/configuration/documents/data-handling" element={<Navigate to="/admin/configuration/documents" replace />} />
                      <Route path="/admin/configuration/documents/:ruleName/edit" element={<AdminDocumentRuleDetail />} />
                      <Route path="/admin/configuration/documents/:ruleName/test" element={<AdminConfigurationRuleTestSimulation />} />
                      <Route path="/admin/configuration/documents/:ruleName" element={<AdminDocumentRuleDetail />} />
                      <Route path="/admin/configuration/routing" element={<Navigate to="/admin/dashboard" replace />} />
                      <Route path="/admin/configuration/routing/*" element={<Navigate to="/admin/dashboard" replace />} />
                      <Route path="/admin/configuration/case-actions/compliance" element={<Navigate to="/admin/configuration/case-actions" replace />} />
                      <Route path="/admin/configuration/case-actions/moderation" element={<Navigate to="/admin/configuration/case-actions" replace />} />
                      <Route path="/admin/configuration/case-actions/fraud-security" element={<Navigate to="/admin/configuration/case-actions" replace />} />
                      <Route path="/admin/configuration/case-actions/messages" element={<Navigate to="/admin/configuration/case-actions" replace />} />
                      <Route path="/admin/configuration/case-actions/support-tickets" element={<Navigate to="/admin/configuration/case-actions" replace />} />
                      <Route path="/admin/configuration/case-actions/data-handling" element={<Navigate to="/admin/configuration/case-actions" replace />} />
                      <Route path="/admin/configuration/case-actions" element={<AdminConfigurationCaseActions />} />
                      <Route path="/admin/configuration/case-actions/add" element={<AdminConfigurationActionRuleDetail />} />
                      <Route path="/admin/configuration/case-actions/:ruleName/edit" element={<AdminConfigurationActionRuleDetail />} />
                      <Route path="/admin/configuration/case-actions/:ruleName/test" element={<AdminConfigurationRuleTestSimulation />} />
                      <Route path="/admin/configuration/case-actions/:ruleName" element={<AdminConfigurationActionRuleDetail />} />
                      <Route path="/admin/configuration/moderation" element={<Navigate to="/admin/configuration/case-actions" replace />} />
                      <Route path="/admin/configuration/moderation/*" element={<Navigate to="/admin/configuration/case-actions" replace />} />
                      <Route path="/admin/configuration/fraud-security" element={<Navigate to="/admin/configuration/case-actions" replace />} />
                      <Route path="/admin/configuration/fraud-security/*" element={<Navigate to="/admin/configuration/case-actions" replace />} />
                      <Route path="/admin/configuration/support-ticket" element={<AdminConfigurationSupportTicket />} />
                      <Route path="/admin/configuration/support-ticket/add" element={<AdminConfigurationSupportTicketDetail />} />
                      <Route path="/admin/configuration/support-ticket/:configId/edit" element={<AdminConfigurationSupportTicketDetail />} />
                      <Route path="/admin/configuration/support-ticket/:configId" element={<AdminConfigurationSupportTicketDetail />} />
                      <Route path="/admin/configuration/limits/login-access" element={<Navigate to="/admin/configuration/limits" replace />} />
                      <Route path="/admin/configuration/limits/messages" element={<Navigate to="/admin/configuration/limits" replace />} />
                      <Route path="/admin/configuration/limits/quotes" element={<Navigate to="/admin/configuration/limits" replace />} />
                      <Route path="/admin/configuration/limits/plans" element={<Navigate to="/admin/configuration/limits" replace />} />
                      <Route path="/admin/configuration/limits/search" element={<Navigate to="/admin/configuration/limits" replace />} />
                      <Route path="/admin/configuration/limits" element={<AdminConfigurationLimitsThresholds />} />
                      <Route path="/admin/configuration/limits/add" element={<AdminConfigurationLimitRuleDetail />} />
                      <Route path="/admin/configuration/limits/:ruleName/edit" element={<AdminConfigurationLimitRuleDetail />} />
                      <Route path="/admin/configuration/limits/:ruleName/test" element={<AdminConfigurationRuleTestSimulation />} />
                      <Route path="/admin/configuration/limits/:ruleName" element={<AdminConfigurationLimitRuleDetail />} />
                      <Route path="/admin/configuration/automation" element={<AdminConfigurationAutomation />} />
                      <Route path="/admin/configuration/automation/add" element={<AdminAutomationRuleDetail />} />
                      <Route path="/admin/configuration/automation/:ruleName/edit" element={<AdminAutomationRuleDetail />} />
                      <Route path="/admin/configuration/automation/:ruleName/test" element={<AdminConfigurationRuleTestSimulation />} />
                      <Route path="/admin/configuration/automation/:ruleName" element={<AdminAutomationRuleDetail />} />
                      <Route path="/admin/configuration/lifecycle" element={<AdminConfigurationLifecycle />} />
                      <Route path="/admin/configuration/lifecycle/add" element={<AdminLifecycleRuleDetail />} />
                      <Route path="/admin/configuration/lifecycle/:ruleName/edit" element={<AdminLifecycleRuleDetail />} />
                      <Route path="/admin/configuration/lifecycle/:ruleName/test" element={<AdminConfigurationRuleTestSimulation />} />
                      <Route path="/admin/configuration/lifecycle/:ruleName" element={<AdminLifecycleRuleDetail />} />
                      <Route path="/admin/configuration/retention" element={<AdminConfigurationRetention />} />
                      <Route path="/admin/configuration/retention/add" element={<AdminRetentionRuleDetail />} />
                      <Route path="/admin/configuration/retention/:ruleName/edit" element={<AdminRetentionRuleDetail />} />
                      <Route path="/admin/configuration/retention/:ruleName/test" element={<AdminConfigurationRuleTestSimulation />} />
                      <Route path="/admin/configuration/retention/:ruleName" element={<AdminRetentionRuleDetail />} />
                      <Route path="/admin/configuration/reporting" element={<Navigate to="/admin/configuration/flag" replace />} />
                      <Route path="/admin/configuration/reporting/*" element={<Navigate to="/admin/configuration/flag" replace />} />
                      <Route path="/admin/configuration/notifications/support-tickets" element={<Navigate to="/admin/configuration/notifications" replace />} />
                      <Route path="/admin/configuration/notifications/billing" element={<Navigate to="/admin/configuration/notifications" replace />} />
                      <Route path="/admin/configuration/notifications/main" element={<Navigate to="/admin/configuration/notifications" replace />} />
                      <Route path="/admin/configuration/notifications" element={<AdminNotificationRules />} />
                      <Route path="/admin/configuration/notifications/add" element={<AdminNotificationRuleDetail />} />
                      <Route path="/admin/configuration/notifications/:ruleName/edit" element={<AdminNotificationRuleDetail />} />
                      <Route path="/admin/configuration/notifications/:ruleName/test" element={<AdminConfigurationRuleTestSimulation />} />
                      <Route path="/admin/configuration/notifications/:ruleName" element={<AdminNotificationRuleDetail />} />
                      <Route path="/admin/settings" element={<Navigate to="/admin/settings/general" replace />} />
                      <Route path="/admin/settings/general" element={<AdminGeneralSettings />} />
                      <Route path="/admin/settings/appearance" element={<Navigate to="/admin/settings/general" replace />} />
                      <Route path="/admin/settings/system-logs" element={<Navigate to="/admin/system-logs" replace />} />
                      <Route path="/admin/settings/features" element={<Navigate to="/admin/settings/general" replace />} />
                      <Route path="/admin/settings/platform-controls" element={<AdminPlatformControls />} />
                      <Route path="/admin/settings/alerts" element={<AdminNotifications />} />
                      <Route path="/admin/settings/security-log" element={<Navigate to="/admin/system-logs?tab=security" replace />} />
                      <Route path="/admin/settings/team-members" element={<AdminTeamMembers />} />
                      <Route path="/admin/settings/team-members/:memberName/edit" element={<AdminTeamMembers />} />
                      <Route path="/admin/settings/team-members/:memberName/reset-password" element={<AdminTeamMembers />} />
                      <Route path="/admin/settings/team-members/:memberName/activate" element={<AdminTeamMembers />} />
                      <Route path="/admin/settings/team-members/:memberName/deactivate" element={<AdminTeamMembers />} />
                      <Route path="/admin/settings/team-members/:memberName" element={<AdminTeamMembers />} />
                      <Route path="/admin/settings/rbac/assign" element={<AdminRolesPermissions />} />
                      <Route path="/admin/settings/rbac/assignment/:assignmentId/edit" element={<AdminRolesPermissions />} />
                      <Route path="/admin/settings/rbac/assignments" element={<AdminRolesPermissions />} />
                      <Route path="/admin/settings/rbac/roles/new" element={<AdminRolesPermissions />} />
                      <Route path="/admin/settings/rbac/roles/:roleId/edit" element={<AdminRolesPermissions />} />
                      <Route path="/admin/settings/rbac/roles" element={<Navigate to="/admin/settings/rbac" replace />} />
                      <Route path="/admin/settings/rbac" element={<AdminRolesPermissions />} />
                      <Route path="/admin/settings/rbac/:roleId" element={<AdminRolesPermissions />} />
                      <Route path="/admin/integrations" element={<AdminIntegrationsConfig />} />
                      <Route path="/admin/settings/integrations" element={<Navigate to="/admin/integrations" replace />} />
                      <Route path="/admin/settings/security" element={<AdminSecurityCompliance />} />
                      <Route path="/admin/settings/data-recovery" element={<Navigate to="/admin/settings/data-requests" replace />} />
                      <Route path="/admin/settings/data-requests" element={<AdminDataRecovery />} />
                      <Route path="/admin/settings/history" element={<AdminSettingsHistory />} />
                      <Route path="/admin/settings/recovery" element={<Navigate to="/admin/settings/data-requests" replace />} />
                      <Route path="/admin/settings/audit" element={<Navigate to="/admin/system-logs" replace />} />
                      <Route path="/admin/settings/audit/:id" element={<Navigate to="/admin/system-logs" replace />} />
                      <Route path="/admin/settings/data" element={<Navigate to="/admin/settings/data-requests" replace />} />
                      <Route path="/admin/settings/notification-log" element={<Navigate to="/admin/system-logs?tab=notifications" replace />} />
                      <Route path="/admin/settings/notification-log/:id" element={<Navigate to="/admin/system-logs?tab=notifications" replace />} />
                    </Route>
          </Routes>
        </Elements>
        <AlertsContainer />
        <CookieBanner />
        </GoogleMapsProvider>
      </div>
    </>
  );
}
export default App;

export const ScrollTop = () => {
  const location = useLocation();
  useEffect(() => {
    if (location.pathname !== "/" && location.hash === "") {
      const time = setTimeout(() => {
        window.scrollTo(0, 0);
        clearTimeout(time);
      }, 200);
    }
  }, [location]);
  return null;
};
